import { Box, LinearProgress } from "@mui/material";
import { v2Colors } from "../../theme/v2Theme";

const ProgressRow = ({
  label,
  value,
  displayValue,
  barColor = v2Colors.progressPurple,
}) => (
  <Box className="edsimsV2-progress-row">
    <Box className="edsimsV2-progress-row-meta">
      <span className="edsimsV2-sim-name">{label}</span>
      <p className="edsimsV2-progress-row-value">
        {displayValue ?? `${value}%`}
      </p>
    </Box>
    <LinearProgress
      variant="determinate"
      value={Math.min(100, Math.max(0, value))}
      className="edsimsV2-progress-row-bar"
      style={{ ["--edsimsV2-progress-bar-color"]: barColor }}
      aria-label={`${label} ${displayValue ?? `${value}%`}`}
    />
  </Box>
);

export default ProgressRow;
